export function str(value, title) {
  if (value === null || value === '' || value === undefined) {
    return '-'
  } else {
    if (title) {
      return value
    } else {
      return value
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/str.js